import { gqlQuery, gqlMutate } from '@hapana/shared/web/services/requests.service'
import {
  availableClientTabsQuery,
  clientsQuery,
  clientQuery,
  createClientMutation,
  updateClientMutation,
  deleteClientMutation,
} from './graphql/clients.queries'
import {
  AVAILABLE_CLIENT_TABS_QUERY_KEY,
  CLIENTS_QUERY_KEY,
  CLIENT_QUERY_KEY,
} from './graphql/clients.queries'

/**
 * Clients Service - Handles all client-related API calls
 */

// Query Service Functions
export const fetchAvailableClientTabs = gqlQuery({
  key: AVAILABLE_CLIENT_TABS_QUERY_KEY,
  query: availableClientTabsQuery,
  options: { isV1: false },
})

export const fetchClientsList = gqlQuery({
  key: CLIENTS_QUERY_KEY,
  query: clientsQuery,
  options: { isV1: false },
})

export const fetchClientById = gqlQuery({
  key: CLIENT_QUERY_KEY,
  query: clientQuery,
  options: { isV1: false },
})

// Mutation Service Functions
export const createClient = async (clientData, siteId = null) => {
  try {
    const response = await gqlMutate({
      mutation: createClientMutation,
      variables: {
        input: clientData,
        siteId: siteId,
      },
      options: { isV1: false },
    })
    return {
      success: true,
      data: response.createClient,
    }
  } catch (_error) {
    throw new Error('Failed to create client')
  }
}

export const updateClient = async (clientId, clientData) => {
  try {
    const response = await gqlMutate({
      mutation: updateClientMutation,
      variables: {
        id: clientId,
        input: clientData,
      },
      options: { isV1: false },
    })
    return {
      success: true,
      data: response.updateClient,
    }
  } catch (_error) {
    throw new Error('Failed to update client')
  }
}

export const deleteClient = async (clientId) => {
  try {
    const response = await gqlMutate({
      mutation: deleteClientMutation,
      variables: {
        id: clientId,
      },
      options: { isV1: false },
    })
    return {
      success: true,
      data: response.deleteClient,
    }
  } catch (_error) {
    throw new Error('Failed to delete client')
  }
}
